import * as Yup from 'yup';
import * as regex from 'src/shared/utils/regex';

export const loginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .max(20, 'Password must be at most 20 characters')
    .matches(
      regex.uppercaseRegex,
      'Password must contain at least one uppercase letter'
    )
    .matches(
      regex.lowercaseRegex,
      'Password must contain at least one lowercase letter'
    )
    .matches(
      regex.specialCharacterRegex,
      'Password must contain at least one special character'
    )
    .matches(regex.digitRegex, 'Password must contain at least one digit')
    .matches(regex.noSpaceRegex, 'Password must not contain spaces')
    .required('Password is required')
});
